import { render, staticRenderFns } from "./C1R_S61.vue?vue&type=template&id=6e7b2b7d&scoped=true"
import script from "./C1R_S61.vue?vue&type=script&lang=js"
export * from "./C1R_S61.vue?vue&type=script&lang=js"
import style0 from "./C1R_S61.vue?vue&type=style&index=0&id=6e7b2b7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7b2b7d",
  null
  
)

export default component.exports